import {
  Badge,
  Button,
  Card,
  CardHeader,
  CardFooter,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  DropdownToggle,
  Media,
  Table,
  Container,
  Row,
  Pagination,
  PaginationItem,
  PaginationLink,
  Modal,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Input,
  Label,
} from "reactstrap";
import { useEffect, useState } from "react";
import Header from "components/Headers/Header.js";
import Loader from "components/Loader.js"; // ✅ Import do Loader
import axios from "axios";

const API_URL = process.env.REACT_APP_AUTH_URL;

const TableUser = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true); // ✅ Novo estado
  const [modalOpen, setModalOpen] = useState(false);
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [newUser, setNewUser] = useState({
    username: "",
    email: "",
    password: "",
    permission: "usuario_comum",
    status: "ativo",
  });
  const [currentUser, setCurrentUser] = useState(null);

  // ✅ Buscar usuários com loader
  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const response = await axios.get(`${API_URL}/users`);
        setUsers(response.data);
      } catch (error) {
        console.error("Erro ao buscar usuários:", error);
      } finally {
        setLoading(false); // ✅ Desliga o loader ao terminar
      }
    };

    fetchUsers();
  }, []);

  const toggleModal = () => setModalOpen(!modalOpen);
  const toggleEditModal = () => setEditModalOpen(!editModalOpen);

  const handleCreateUser = async () => {
    try {
      const response = await axios.post(`${API_URL}/register`, newUser);
      setUsers([...users, response.data.user]);
      setNewUser({
        username: "",
        email: "",
        password: "",
        permission: "usuario_comum",
        status: "ativo",
      });
      toggleModal();
    } catch (error) {
      console.error("Erro ao criar usuário:", error);
    }
  };

  const handleEditUser = async () => {
    try {
      const response = await axios.put(`${API_URL}/users/${currentUser.id}`, currentUser);
      setUsers(users.map((user) => (user.id === currentUser.id ? response.data.user : user)));
      toggleEditModal();
    } catch (error) {
      console.error("Erro ao atualizar usuário:", error);
    }
  };

  const handleDeleteUser = async (id) => {
    try {
      await axios.delete(`${API_URL}/users/${id}`);
      setUsers(users.filter((user) => user.id !== id));
    } catch (error) {
      console.error("Erro ao deletar usuário:", error);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewUser({ ...newUser, [name]: value });
  };

  const handleEditInputChange = (e) => {
    const { name, value } = e.target;
    setCurrentUser({ ...currentUser, [name]: value });
  };

  const openEditModal = (user) => {
    setCurrentUser(user);
    toggleEditModal();
  };

  // ✅ Loader enquanto carrega
  if (loading) {
    return (
      <>
        <Header />
        <Loader />
      </>
    );
  }

  return (
    <>
      <Header />
      <Container className="mt--7" fluid>
        <Row>
          <div className="col">
            <Card className="shadow">
              <CardHeader className="border-0 d-flex justify-content-between align-items-center">
                <h3 className="mb-0">Lista de Usuários</h3>
                <Button color="primary" onClick={toggleModal}>
                  Adicionar Novo Usuário
                </Button>
              </CardHeader>

              <Table className="align-items-center table-flush" responsive>
                <thead className="thead-light">
                  <tr>
                    <th scope="col">Nome de Usuário</th>
                    <th scope="col">Email</th>
                    <th scope="col">Permissão</th>
                    <th scope="col">Status</th>
                    <th scope="col" />
                  </tr>
                </thead>
                <tbody>
                  {users.map((user) => (
                    <tr key={user.id}>
                      <th scope="row">
                        <Media className="align-items-center">
                          <span className="mb-0 text-sm">{user.username}</span>
                        </Media>
                      </th>
                      <td>{user.email}</td>
                      <td>
                        <Badge color={user.permission === "administrador" ? "primary" : "secondary"}>
                          {user.permission}
                        </Badge>
                      </td>
                      <td>
                        <Badge color={user.status === "ativo" ? "success" : "danger"}>
                          {user.status}
                        </Badge>
                      </td>
                      <td className="text-right">
                        <UncontrolledDropdown>
                          <DropdownToggle
                            className="btn-icon-only text-light"
                            href="#pablo"
                            role="button"
                            size="sm"
                            color=""
                            onClick={(e) => e.preventDefault()}
                          >
                            <i className="fas fa-ellipsis-v" />
                          </DropdownToggle>
                          <DropdownMenu className="dropdown-menu-arrow" right>
                            <DropdownItem onClick={() => openEditModal(user)}>
                              Editar
                            </DropdownItem>
                            <DropdownItem onClick={() => handleDeleteUser(user.id)}>
                              Deletar
                            </DropdownItem>
                          </DropdownMenu>
                        </UncontrolledDropdown>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>

              <CardFooter className="py-4">
                <Pagination className="pagination justify-content-end mb-0">
                  <PaginationItem disabled>
                    <PaginationLink href="#">
                      <i className="fas fa-angle-left" />
                    </PaginationLink>
                  </PaginationItem>
                  <PaginationItem active>
                    <PaginationLink href="#">1</PaginationLink>
                  </PaginationItem>
                  <PaginationItem>
                    <PaginationLink href="#">
                      <i className="fas fa-angle-right" />
                    </PaginationLink>
                  </PaginationItem>
                </Pagination>
              </CardFooter>
            </Card>
          </div>
        </Row>
      </Container>


      {/* Modal para criar um novo usuário */}
      <Modal isOpen={modalOpen} toggle={toggleModal}>
        <div className="modal-header">
          <h5 className="modal-title" id="exampleModalLabel">
            Adicionar Novo Usuário
          </h5>
          <button
            aria-label="Close"
            className="close"
            type="button"
            onClick={toggleModal}
          >
            <span aria-hidden={true}>×</span>
          </button>
        </div>
        <ModalBody>
          <Form>
            <FormGroup>
              <Label for="username">Username</Label>
              <Input
                type="text"
                id="username"
                name="username"
                value={newUser.username}
                onChange={handleInputChange}
                placeholder="Nome de usuário"
              />
            </FormGroup>
            <FormGroup>
              <Label for="email">Email</Label>
              <Input
                type="email"
                id="email"
                name="email"
                value={newUser.email}
                onChange={handleInputChange}
                placeholder="Email"
              />
            </FormGroup>
            <FormGroup>
              <Label for="password">Senha</Label>
              <Input
                type="password"
                id="password"
                name="password"
                value={newUser.password}
                onChange={handleInputChange}
                placeholder="Senha"
              />
            </FormGroup>
            <FormGroup>
              <Label for="permission">Permissão</Label>
              <Input
                type="select"
                id="permission"
                name="permission"
                value={newUser.permission}
                onChange={handleInputChange}
              >
                <option value="usuario_comum">Usuário Comum</option>
                <option value="administrador">Administrador</option>
              </Input>
            </FormGroup>
            <FormGroup>
              <Label for="status">Status</Label>
              <Input
                type="select"
                id="status"
                name="status"
                value={newUser.status}
                onChange={handleInputChange}
              >
                <option value="ativo">Ativo</option>
                <option value="inativo">Inativo</option>
              </Input>
            </FormGroup>
          </Form>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={handleCreateUser}>
            Criar Usuário
          </Button>
          <Button color="secondary" onClick={toggleModal}>
            Cancelar
          </Button>
        </ModalFooter>
      </Modal>

      {/* Modal para editar usuário */}
      <Modal isOpen={editModalOpen} toggle={toggleEditModal}>
        <div className="modal-header">
          <h5 className="modal-title" id="exampleModalLabel">
            Editar Usuário
          </h5>
          <button
            aria-label="Close"
            className="close"
            type="button"
            onClick={toggleEditModal}
          >
            <span aria-hidden={true}>×</span>
          </button>
        </div>
        <ModalBody>
          <Form>
            <FormGroup>
              <Label for="username">Username</Label>
              <Input
                type="text"
                id="username"
                name="username"
                value={currentUser?.username || ""}
                onChange={handleEditInputChange}
              />
            </FormGroup>
            <FormGroup>
              <Label for="email">Email</Label>
              <Input
                type="email"
                id="email"
                name="email"
                value={currentUser?.email || ""}
                onChange={handleEditInputChange}
              />
            </FormGroup>
            <FormGroup>
              <Label for="permission">Permissão</Label>
              <Input
                type="select"
                id="permission"
                name="permission"
                value={currentUser?.permission || "usuario_comum"}
                onChange={handleEditInputChange}
              >
                <option value="usuario_comum">Usuário Comum</option>
                <option value="administrador">Administrador</option>
              </Input>
            </FormGroup>
            <FormGroup>
              <Label for="status">Status</Label>
              <Input
                type="select"
                id="status"
                name="status"
                value={currentUser?.status || "ativo"}
                onChange={handleEditInputChange}
              >
                <option value="ativo">Ativo</option>
                <option value="inativo">Inativo</option>
              </Input>
            </FormGroup>
          </Form>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={handleEditUser}>
            Atualizar Usuário
          </Button>
          <Button color="secondary" onClick={toggleEditModal}>
            Cancelar
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default TableUser;